import React, { useState, useEffect } from 'react'
import { Input, Button, Tooltip, Icon, message } from 'antd'
import { FormItem } from '../../components'
import { getDomainSetting } from '../../../../api/taobaoDomainChange'
import { getPostSetting, savePostSetting, checkPushUrl } from '../../../../api/multiDomain';
import './style.less';

const clsPrefix = "md-setting";
const iconStyle = {
  color: 'rgba(0,0,0,0.4)',
  cursor:'pointer',
  marginLeft: '10px'
};

interface AppInfo {
  appId: string,
  appSecret: string
};

const Setting:React.FC<{
  userId:string
}> = ({userId}) => {
  const [ apiPost, setApiPost ] = useState() 
  const [ messagePost, setMessagePost ] = useState();
  const [ appInfo, setAppInfo ] = useState<AppInfo>({ appId: '2343434232', appSecret: '2dsad34dsadsfddfadfa'})

  useEffect(() => {
    if (userId) {
      // @ts-ignore
      getDomainSetting(userId).then((data: AppInfo) => {
        setAppInfo({
          appId: data.appId,
          appSecret: data.appSecret
        })
      })
    }
    // @ts-ignore
    getPostSetting().then((data: { pushVo: { pushUrl: string, phone: string }}) => {
      setApiPost(data.pushVo && data.pushVo.pushUrl)
      setMessagePost(data.pushVo && data.pushVo.phone)
    })
  }, [])

  function handleSaveSetting() {
    savePostSetting({
      userId,
      phone: messagePost,
      pushUrl: apiPost
    }).then(() => {
      message.success('保存成功')
    }).catch(() => {
      message.error('保存失败')
    })
  }

  function checkUrl() {
    if (!apiPost) {
      return;
    }
    checkPushUrl(apiPost).then(() => {
      return true;
    }).catch((error) => {
      if (error.code === 50003) {
        message.error(error.msg);
        setApiPost('');
      } else {
        console.log(error)
      }
    })
  }
  return(
    <div className={clsPrefix}>

      <div className={`${clsPrefix}__secret-key`}>
        <div className={`${clsPrefix}__secret-key--title`}>接口密钥</div>
        <p>AppId: {appInfo.appId}</p>
        <p>AppSecret: {appInfo.appSecret}</p>
      </div>

      <div className={`${clsPrefix}__notice`}>
        <div className={`${clsPrefix}__notice--title`}>
          <div>消息推送</div>
          <div className={`${clsPrefix}__notice--title-tip`}>域名被防洪时推送</div>
        </div>
        <FormItem title="接口推送">
          <Input value={apiPost} onChange={(e) => setApiPost(e.target.value)} onBlur={checkUrl} />
          <Tooltip title="点击查看接口文档" placement="right">
            <Icon type="question-circle" style={iconStyle} />
          </Tooltip>
        </FormItem>
        <FormItem title="短信推送" tip="每天每个账号最多推送5条短信">
          <Input value={messagePost} onChange={e => setMessagePost(e.target.value)} placeholder="请输入手机号" />
        </FormItem>
        <Button
          className={`${clsPrefix}__notice--btn`}
          size="large"
          type="primary"
          onClick={() => handleSaveSetting()}
        >
          保存设置
        </Button>
      </div>
    </div>
  )
}

export default Setting